import {CONTENTFUL_API_KEY, CONTENTFUL_SPACE_KEY} from "./contentfulVariables";
import {Environment, Network, RecordSource, Store} from 'relay-runtime';

export async function fetchGraphQL(text, variables) {
    // Fetch data from Contentful's GraphQL API:
    const response = await fetch(`https://graphql.contentful.com/content/v1/spaces/${CONTENTFUL_SPACE_KEY}`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${CONTENTFUL_API_KEY}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query: text,
            variables,
        }),
    });
    // Get the response as JSON
    return await response.json();
}

export const fetchRelay = async (params, variables) => fetchGraphQL(params.text, variables);

export const GRAPHQL_ENVIRONMENT = new Environment({
    network: Network.create(fetchRelay),
    store: new Store(new RecordSource())
})